/* TPW Military & First Responder 15% discount walkthrough (2026-10-20).
   Opens from any [data-tpw-mil] link/button (footer link) or the URL hash #military-discount.
   Same modal shell/behavior as tpw-gift-howto.js: phones/portrait = full screen navy, desktop = large 16:9 player.
   The stage markup comes from <template id="tpw-mil-tpl"> (snippets/tpw-mil-howto.liquid); the inline copy on
   /pages/military-first-responder-discount uses the same Player. GTM: dataLayer mil_howto_open / mil_howto_cta. */
(function(){
  if(window.TPWMil)return;
  var HASH='#military-discount',PORTRAIT='(max-width:600px), (orientation:portrait)';
  var RM=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)');
  function reduced(){return !!(RM&&RM.matches);}
  function dl(o){try{(window.dataLayer=window.dataLayer||[]).push(o);}catch(e){}}

  function Player(root){
    var self=this,scenes=[].slice.call(root.querySelectorAll('.tpw-mil__scene')),segs=[].slice.call(root.querySelectorAll('.tpw-mil__bar i'));
    var live=root.querySelector('.tpw-mil__live'),prev=root.querySelector('[data-mil-prev]'),next=root.querySelector('[data-mil-next]'),tog=root.querySelector('[data-mil-toggle]');
    var i=0,el=0,last=0,raf=0,playing=false,running=false,LAST=scenes.length-1;
    function dur(n){return +scenes[n].getAttribute('data-dur')||0;}
    function fit(){
      root.querySelectorAll('.tpw-mil__vis').forEach(function(v){
        var w=v.clientWidth,h=v.clientHeight;if(!w||!h)return;
        v.style.setProperty('--s',Math.max(.35,Math.min(w/264,h/534,1.35)).toFixed(3));
      });
    }
    function bar(){
      segs.forEach(function(s,k){var n=k+1;s.classList.toggle('is-done',n<i||i===LAST);s.classList.remove('is-cur');});
      if(i>=1&&i<LAST){var s=segs[i-1];s.style.setProperty('--d',dur(i)+'ms');void s.offsetWidth;s.classList.add('is-cur');}
    }
    function ui(){
      prev.disabled=i===0;next.disabled=i===LAST;
      root.classList.toggle('is-paused',!playing&&i!==LAST);root.classList.toggle('is-ended',i===LAST);
      tog.setAttribute('aria-label',i===LAST?'Replay':(playing?'Pause':'Play'));
    }
    function go(n,user){
      n=Math.max(0,Math.min(LAST,n));
      scenes.forEach(function(s,k){if(k!==n)s.classList.remove('is-on');s.setAttribute('aria-hidden',k===n?'false':'true');if('inert' in s)s.inert=k!==n;});
      var s=scenes[n];s.classList.remove('is-on');void s.offsetWidth;s.classList.add('is-on');
      i=n;el=0;
      if(n===LAST)playing=false;
      bar();ui();fit();
      var h=s.querySelector('.tpw-mil__h');if(live&&h&&user!==false)live.textContent=(n>=1&&n<LAST?'Step '+n+' of '+(LAST-1)+': ':'')+h.textContent;
    }
    function tick(t){
      raf=0;if(!running)return;
      if(playing&&dur(i)){el+=Math.min(100,t-last);if(el>=dur(i)){go(i+1);}}
      last=t;raf=requestAnimationFrame(tick);
    }
    function loop(){if(!raf){last=performance.now();raf=requestAnimationFrame(tick);}}
    this.start=function(from){running=true;playing=!reduced();go(from||0,false);loop();};
    this.stop=function(){running=false;playing=false;if(raf)cancelAnimationFrame(raf);raf=0;ui();};
    this.pause=function(){if(!playing)return;playing=false;ui();};
    this.fit=fit;
    prev.addEventListener('click',function(){go(i-1);});
    next.addEventListener('click',function(){go(i+1);});
    tog.addEventListener('click',function(){if(i===LAST){playing=!reduced();go(0);return;}playing=!playing;ui();});
    var rp=root.querySelector('[data-mil-replay]');if(rp)rp.addEventListener('click',function(){playing=!reduced();go(0);var f=root.querySelector('[data-mil-next]');f&&f.focus({preventScroll:true});});
    root.querySelectorAll('[data-mil-cta]').forEach(function(a){a.addEventListener('click',function(){dl({event:'mil_howto_cta',mil_howto_cta:a.getAttribute('data-mil-cta'),mil_howto_location:root.getAttribute('data-tpw-mil-stage')});});});
    if(window.ResizeObserver)new ResizeObserver(function(){fit();}).observe(root);else window.addEventListener('resize',fit);
    this.cart=function(n){root.classList.toggle('has-cart',n>0);root.querySelectorAll('[data-mil-cart-only]').forEach(function(a){a.hidden=!(n>0);});};
    this.cart(+root.getAttribute('data-cart')||0);
  }
  function refreshCart(p){
    try{fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.ok?r.json():null;}).then(function(c){if(c)p.cart(c.item_count||0);}).catch(function(){});}catch(e){}
  }

  var modal,box,closeBtn,player,lastFocus,where='footer';
  function build(){
    var tpl=document.getElementById('tpw-mil-tpl');if(!tpl)return false;
    modal=document.createElement('div');modal.className='tpw-mil-modal';modal.hidden=true;
    modal.setAttribute('role','dialog');modal.setAttribute('aria-modal','true');modal.setAttribute('aria-label','Military & First Responder Discount: how it works');
    modal.innerHTML='<div class="tpw-mil-modal__box"><button type="button" class="tpw-mil-modal__x" aria-label="Close">&times;</button></div>';
    box=modal.firstChild;closeBtn=box.firstChild;
    box.appendChild(tpl.content?document.importNode(tpl.content,true):document.createRange().createContextualFragment(tpl.innerHTML));
    document.body.appendChild(modal);
    player=new Player(box.querySelector('.tpw-mil'));
    closeBtn.addEventListener('click',close);
    modal.addEventListener('click',function(e){if(!box.contains(e.target))close();});
    document.addEventListener('keydown',function(e){if(modal.hidden)return;
      if(e.key==='Escape'||e.key==='Esc'){e.preventDefault();close();}
      else if(e.key==='Tab'){
        var f=[].slice.call(box.querySelectorAll('button,a[href],[tabindex]:not([tabindex="-1"])')).filter(function(x){return !x.disabled&&!x.hidden&&x.offsetParent!==null&&!x.closest('[inert]');});
        if(!f.length)return;var k=f.indexOf(document.activeElement);e.preventDefault();
        f[k<0?0:(k+(e.shiftKey?f.length-1:1))%f.length].focus();
      }});
    window.addEventListener('resize',function(){if(!modal.hidden)layout();});
    return true;
  }
  function layout(){
    var port=!!(window.matchMedia&&matchMedia(PORTRAIT).matches);
    modal.classList.toggle('tpw-mil-modal--port',port);
    box.querySelector('.tpw-mil').classList.toggle('tpw-mil--land',!port);
    player.fit();
  }
  function open(src){
    if(!modal&&!build())return;
    if(!modal.hidden)return;
    where=src||'footer';lastFocus=document.activeElement;
    modal.hidden=false;document.documentElement.classList.add('tpw-mil-lock');
    layout();
    requestAnimationFrame(function(){modal.classList.add('is-open');player.fit();});
    player.start(0);refreshCart(player);
    closeBtn.focus({preventScroll:true});
    dl({event:'mil_howto_open',mil_howto_location:where});
  }
  function close(){
    if(!modal||modal.hidden)return;
    player.stop();
    modal.classList.remove('is-open');modal.hidden=true;document.documentElement.classList.remove('tpw-mil-lock');
    if(location.hash===HASH&&history.replaceState)history.replaceState(null,'',location.pathname+location.search);
    if(lastFocus&&lastFocus.focus&&document.contains(lastFocus))lastFocus.focus({preventScroll:true});
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest&&e.target.closest('[data-tpw-mil],a[href$="'+HASH+'"]');if(!b)return;
    if(e.metaKey||e.ctrlKey||e.shiftKey||e.button===1)return;
    if(!document.getElementById('tpw-mil-tpl'))return;
    e.preventDefault();open(b.getAttribute('data-tpw-mil')||'link');
  });
  function fromHash(){if(location.hash===HASH)open('hash');}
  window.addEventListener('hashchange',fromHash);

  function initInline(){
    document.querySelectorAll('[data-tpw-mil-stage="page"]').forEach(function(root){
      if(root.__mil)return;var p=root.__mil=new Player(root);
      function lay(){root.classList.toggle('tpw-mil--land',root.clientWidth>=750);p.fit();}
      lay();window.addEventListener('resize',lay);refreshCart(p);
      var started=false;
      if(window.IntersectionObserver)new IntersectionObserver(function(es){es.forEach(function(en){if(en.isIntersecting&&!started){started=true;p.start(0);}else if(!en.isIntersecting&&started){p.pause();}});},{threshold:.35}).observe(root);
      else p.start(0);
    });
  }
  function init(){initInline();fromHash();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  window.TPWMil={open:open,close:close,isOpen:function(){return !!modal&&!modal.hidden;}};
})();
